import {Component, ContentChild, input, output, computed, signal, AfterContentInit, OnDestroy, ChangeDetectorRef, AfterViewChecked} from '@angular/core';
import {NgControl, FormControl} from '@angular/forms';
import {Subscription} from 'rxjs';

@Component({
    selector: 'read-only-form-field',
    templateUrl: './read-only-form-field.component.html',
    standalone: false
})
export class ReadOnlyFormFieldComponent implements AfterContentInit, AfterViewChecked, OnDestroy {
  @ContentChild(NgControl) control?: NgControl;
  
  value= input<string | number | undefined | null>('')
  readonly = input<boolean>(true);
  title = input<string>('');
  testId = input<string>('');
  isDate = input<boolean>(false);
  displayPropFunc = input<(value:any)=> string | number>((value)=> value);
  buttonIcon = input<{icon: string, tooltip:string}>();
  buttonClick = output<string | number | undefined | null>();
  
  private controlValue = signal<any>(null);
  private subscription?: Subscription;
  private lastControl?: FormControl;
  
  constructor(private cdr: ChangeDetectorRef) {}
  
  ngAfterContentInit() {
    this.setupSubscription();
  }
  
  ngAfterViewChecked() {
    const currentControl = this.control?.control as FormControl;
    if (currentControl && currentControl !== this.lastControl) {
      this.lastControl = currentControl;
      this.setupSubscription();
    }
  }
  
  private setupSubscription() {
    this.subscription?.unsubscribe();
    
    if (this.control) {
      const formControl = this.control.control as FormControl;
      if (formControl) {
        this.controlValue.set(formControl.value);
        
        this.subscription = formControl.valueChanges?.subscribe(value => {
          this.controlValue.set(value);
          this.cdr.markForCheck();
        });
      }
    }
  }
  
  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }
  
  innerValue = computed(() => {
    if (!this.control) return this.value() ?? '';
    const value = this.controlValue() ?? this.control.value ?? '';
    if (this.readonly()) this.showContent = false;
    return value;
  });
  showContent = true;

  handleIconButton(): void {
    this.buttonClick.emit(this.value());
  }
}
